module.exports = "/_next/static/images/game-1-intro-tutorial-underline2-1-e5da3fe4e6833576ce973c44029bf5cb.png";